import ApiService from '@/plugins/api-plugin/services/api.service'

export default class CommonLambdaService extends ApiService {}
